module.exports = __webpack_public_path__ + "static/TT-Plans-Fact_Sheet-d0faba6504df5df958c063392a017049.pdf";